import React, {useState} from "react";
import firebase from "../../firebase";
import {MainWrapper, RegistrationWrapper} from "./styles";
import RegistrationMask from "../../components/RegistrationMask";
import Tabs from "../../components/Tabs";
import Bannerone from "../../components/Bannerone";
import Header from "../../components/Header";

export default function Home(props) {
  const [mailValue, setMailValue] = useState("");
  const [password, setPasswordValue] = useState("");
  const [passwordBis, setPasswordBisValue] = useState("");
  const [error, setErrorMessage] = useState("");
  const [inlineMessage, setInlineMessage] = useState("");
  const [isLogged, setIsLogged] = useState(false);
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [school, setSchool] = useState("");
  const [city, setCity] = useState("");
  const [privacyCheck, setPrivacy] = useState(false);

  const translateErrorMessage = (errorCode) => {
    switch (errorCode) {
      case "auth/invalid-email":
        return "Indirizzo email non esistente";
      case "auth/email-already-in-use":
        return "Indirizzo email già utilizzato";
      case "auth/weak-password":
        return "Password troppo debole, deve essere almeno 6 caratteri";
      case "auth/user-not-found":
        return "Utente non trovato, sei sicuro di esserti già registrato?";
      case "auth/wrong-password":
        return "L'email o la password inserite non sono corrette";
      default:
        return "Si è verificato un errore, ricontrolla i tuoi dati";
    }
  };

  const handleRegister = (mailValue, password, name, surname, city, school) => {
    setErrorMessage("");
    console.log(school);
    if (password === passwordBis && privacyCheck && name && surname && city && school !== "") {
      const db = firebase.firestore();
      const data = {nome: name, surname: surname, school: school, city: city};
      var myUserId = db.collection("users").doc(mailValue);
      myUserId.set(data);
      firebase
        .auth()
        .createUserWithEmailAndPassword(mailValue, password)
        .then((userCredential) => {
          const user = userCredential.user;
          console.log(user, "correctly registered");
          setInlineMessage("Utenza correttamente registrata! Adesso puoi loggarti");
          props.history.push("/project?login");
        })
        .catch((error) => {
          const errorToShow = translateErrorMessage(error.code);
          setErrorMessage(errorToShow);
        });
    } else if (privacyCheck && (!name || !surname || !city || school === "")) {
      setErrorMessage("Controlla di aver inserito tutti i campi");
    } else if (!privacyCheck && password === passwordBis) {
      setErrorMessage("È necessario il tuo consenso per la privacy");
    } else {
      setErrorMessage("Controlla di avere inserito correttamente le password");
    }
  };

  const handleLogin = (mailValue, password) => {
    setErrorMessage("");
    firebase
      .auth()
      .signInWithEmailAndPassword(mailValue, password)
      .then((userCredential) => {
        const user = userCredential.user;
        setIsLogged(true);
        console.log(user, "logged in");
      })
      .catch((error) => {
        const errorMessage = translateErrorMessage(error.code);
        setErrorMessage(errorMessage);
      });
  };

  const [pos, setScrollPos] = useState(0);

  const hanldeScrollPos = (e) => {
    setScrollPos(e.target.scrollTop);
  };

  return !isLogged ? (
    <RegistrationWrapper>
      <Header
        history={props.history}
        screen="form"
        firstButton={{
          label: window.location.hash.split("?")[1] === "register" ? "ACCEDI" : "REGISTRATI",
          action: () =>
            props.history.push(
              window.location.hash.split("?")[1] === "register" ? "/project?login" : "/project?register",
            ),
        }}
      />
      <RegistrationMask
        type={window.location.hash.split("?")[1]}
        mailValue={mailValue}
        password={password}
        passwordBis={passwordBis}
        name={name}
        onChangeName={(e) => setName(e.target.value)}
        surname={surname}
        onChangeSurName={(e) => setSurname(e.target.value)}
        school={school}
        onChangeSchool={(e) => setSchool(e.target.value)}
        city={city}
        onChangeCity={(e) => setCity(e.target.value)}
        onChangeMail={(e) => setMailValue(e.target.value)}
        onChangePsw={(e) => setPasswordValue(e.target.value)}
        onChangePswBis={(e) => setPasswordBisValue(e.target.value)}
        onCheckPrivacy={() => setPrivacy(!privacyCheck)}
        privacyCheck={privacyCheck}
        error={error}
        inlineMessage={inlineMessage}
        handleLogin={() => handleLogin(mailValue, password)}
        handleRegister={() => handleRegister(mailValue, password, name, surname, city, school)}
      />
    </RegistrationWrapper>
  ) : (
    <MainWrapper onScroll={(e) => hanldeScrollPos(e)}>
      <Header
        id="header"
        screen="form"
        secondButton={{action: () => props.history.push("/"), label: "ESCI"}}
        history={props.history}
      />
      <Bannerone />
      <Tabs pos={pos} />
      {pos > 1237 && (
        <span
          onClick={() => {
            document.getElementById("header").scrollIntoView();
          }}
        >
          <svg width="78" height="78" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <defs>
              <path id="j" d="M0 0h46v26H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
              <circle fill="#F5A462" fillRule="nonzero" cx="39" cy="39" r="39" />
              <g transform="rotate(-180 31 26)">
                <mask id="x" fill="#fff">
                  <use xlinkHref="#j" />
                </mask>
                <path
                  d="M22.999924 26c-.824414 0-1.648726-.312123-2.277267-.935055L.943652 5.452706C-.31455 4.205125-.31455 2.182385.943652.935308 2.201346-.31177 4.2409-.31177 5.499204.935308L22.999924 18.2893 40.500744.935913c1.258306-1.247077 3.297553-1.247077 4.555146 0 1.258814 1.247077 1.258814 3.269817 0 4.517399L25.27719 25.06555c-.628846.623034-1.453158.93445-2.277266.93445"
                  fill="#FFF"
                  mask="url(#x)"
                />
              </g>
            </g>
          </svg>
        </span>
      )}
    </MainWrapper>
  );
}
